import { NavLink, useLocation } from 'react-router-dom';
import './BottomNav.css';
import CustomerServiceIcon from './CustomerServiceIcon';

// 导入图标图片
import homeInactive from '../image/首页未选中.png';
import homeActive from '../image/首页选中.png';
import joinInactive from '../image/入驻未选择.png';
import joinActive from '../image/入驻选中.png';
import myInactive from '../image/我的未选中.png';
import myActive from '../image/我的选中.png';

const BottomNav = () => {
  const location = useLocation();

  // 定义需要显示底部导航栏的页面路径
  // 只在主要导航页面显示，提升用户在详情页面和流程页面的沉浸式体验
  const showNavPaths = ['/', '/join', '/customer-service', '/my'];

  // 检查当前路径是否需要显示导航栏
  const shouldShowNav = showNavPaths.includes(location.pathname);

  // 如果当前页面不需要显示导航栏，则返回null
  // 隐藏导航栏的页面包括：/detail, /payment, /payment-success, /booking, /profile 等
  if (!shouldShowNav) {
    return null;
  }

  return (
    <nav className="bottom-nav" role="navigation" aria-label="底部导航">
      <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        {({ isActive }) => (
          <>
            <img
              src={isActive ? homeActive : homeInactive}
              alt="首页"
              className="nav-icon"
            />
            <span className="label">首页</span>
          </>
        )}
      </NavLink>
      <NavLink to="/join" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        {({ isActive }) => (
          <>
            <img
              src={isActive ? joinActive : joinInactive}
              alt="入驻"
              className="nav-icon"
            />
            <span className="label">入驻</span>
          </>
        )}
      </NavLink>
      <NavLink to="/customer-service" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        {({ isActive }) => (
          <>
            <CustomerServiceIcon isActive={isActive} />
            <span className="label">客服</span>
          </>
        )}
      </NavLink>
      <NavLink to="/my" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
        {({ isActive }) => (
          <>
            <img
              src={isActive ? myActive : myInactive}
              alt="我的"
              className="nav-icon"
            />
            <span className="label">我的</span>
          </>
        )}
      </NavLink>
    </nav>
  );
};

export default BottomNav;

